import { OverlayTrigger, Tooltip } from 'react-bootstrap';

/**
 * How an operator sits against everyone else who ran the SAME product, in the
 * SAME phase, on the SAME machine.
 *
 * `higherIsBetter` flips the colour: for speed, above the group is good; for
 * changeover time, below it is.
 *
 * A null delta means there are no peers — nobody else has run this work — which
 * is a different statement from "exactly average" and must not look like one.
 */
const PeerDelta = ({ delta, peers = 0, peerValue = null, unit = '', higherIsBetter = true }) => {
  if (delta == null || peers < 2) {
    return (
      <OverlayTrigger
        placement="top"
        overlay={<Tooltip>Nobody else has run this — nothing to compare against</Tooltip>}
      >
        <span className="text-600 fs-10">no peers</span>
      </OverlayTrigger>
    );
  }

  const good = higherIsBetter ? delta > 0 : delta < 0;
  const flat = Math.abs(delta) < 3; // within noise
  const cls = flat ? 'text-700' : good ? 'text-success' : 'text-danger';
  const arrow = flat ? '−' : delta > 0 ? '▲' : '▼';

  return (
    <OverlayTrigger
      placement="top"
      overlay={
        <Tooltip>
          Group median {peerValue != null ? `${peerValue}${unit}` : '—'} across {peers} operators
        </Tooltip>
      }
    >
      <span className={`${cls} fw-semibold fs-10 text-nowrap`}>
        {arrow} {delta > 0 ? '+' : ''}
        {delta}%
      </span>
    </OverlayTrigger>
  );
};

export default PeerDelta;
